import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ImageModule } from '@df/module-image/image.module';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { defaultImage } from 'projects/app-default/src/app/icms.config';
interface IItemData {
    image: string;
    caption: string;
}
interface IPageComponentPostImageSectionData extends NICmsContentComponent.IData {
    images: IItemData[];
}
@ICmsComponent<PageComponentPostImageSectionComponent>({
    id: 'post-image-section',
    name: 'Post Image Section',
    tags: ['blog', 'post', 'image', 'section'],
    fields: [
        <NICmsContentField.IRepeaterField>{
            key: 'images',
            type: NICmsContentField.EFieldType.repeater,
            title: 'Images',
            itemName: 'Image',
            maxSize: 2,
            fields: [
                <NICmsContentField.IField>{
                    key: 'image',
                    type: NICmsContentField.EFieldType.image,
                    title: 'Image',
                    default: defaultImage,
                    required: true
                },
                <NICmsContentField.IField>{
                    key: 'caption',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Caption',
                    default: 'Caption',
                    required: true
                }
            ]
        }
    ]
})
@Component({
    selector: 'page-component-post-image-section',
    templateUrl: './post-image-section.html',
    standalone: true,
    imports: [NgClass, ImageModule, ICmsClientModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageComponentPostImageSectionComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component!: IPageComponentPostImageSectionData;
}
